import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import ReportWidget from './ReportWidget';
import LoadingPage from '../LoadingPage';
import Chart from '../../util/chart';
import { convertToArrayOfObjects } from '../../util/report';

class WEBPI1Widget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sales: {},
      isReady: false,
    };

    this.sales = {
      'Front Counter': {
        name: 'Front Counter',
        total: 0.0,
        profit: 0.0,
      },
      'Back Counter': {
        name: 'Back Counter',
        total: 0.0,
        profit: 0.0,
      },
    };
  }

  getMonthAndYear() {
    // Use date in past to get data in dev
    return process.env.NODE_ENV === 'development' ? [1, 2017] : [moment().format('M'), moment().format('YYYY')];
  }

  handleData = ({ data, cols }) => {
    // transform array of positional data to array of json objects
    data = convertToArrayOfObjects(data, cols);

    const sales = _.cloneDeep(this.sales);
    data.forEach(row => {
      const bcsales = parseFloat(row.bcsales);
      const bcgpdol = parseFloat(row.bcgpdol);
      const fcsales = parseFloat(row.fcsales);
      const fcgpdol = parseFloat(row.fcgpdol);

      sales['Back Counter'].profit += !isNaN(bcgpdol) ? bcgpdol : 0.0;
      sales['Back Counter'].total += !isNaN(bcsales) ? bcsales : 0.0;
      sales['Front Counter'].profit += !isNaN(fcgpdol) ? fcgpdol : 0.0;
      sales['Front Counter'].total += !isNaN(fcsales) ? fcsales : 0.0;
    });

    this.setState({ sales, isReady: true }, this.renderCharts);
  };

  renderCharts() {
    Chart.makeBarChart('webpi1-widget-chart-1', {
      titles: [
        {
          text: 'Sales and Profit (This Month)',
        },
      ],
      dataProvider: [this.state.sales['Front Counter'], this.state.sales['Back Counter']],
      valueAxes: [
        {
          unit: '$',
          unitPosition: 'left',
        },
      ],
      graphs: [
        Chart.getBarGraph({
          balloonText: 'Sales for [[category]]: $[[value]]',
          title: 'Sales',
          valueField: 'total',
          fillColors: ['#03A9F4'],
        }),
        Chart.getBarGraph({
          balloonText: 'Profit for [[category]]: $[[value]]',
          title: 'Profit',
          valueField: 'profit',
          fillColors: ['#81C784'],
        }),
      ],
      rotate: true,
      categoryField: 'name',
      categoryAxis: {
        gridPosition: 'start',
        fillAlpha: 0.05,
        position: 'left',
      },
    });
  }

  render() {
    return (
      <ReportWidget
        pageName="WEBPI1"
        reportOptions={['MONTH', ...this.getMonthAndYear(), 'Y', 'Y', 'Y']}
        handleData={this.handleData}
      >
        {this.state.isReady ? <div id="webpi1-widget-chart-1" className="carousel-cell" /> : <LoadingPage />}
      </ReportWidget>
    );
  }
}

export default WEBPI1Widget;
